import ApiService from "@/service/ApiService";

export default function useRegister() {
  const Register = async (data) => {
    return await ApiService.post("query/register_query_communitys", data);
  };

  const UpdateUser = async (data) => {
    return await ApiService.put("query/edit_user/" + data.id_line, data);
  };

  return {
    Register,
    UpdateUser,
  };
}
